import Vue from 'vue'

export default {
  notify(exception, validationKey) {
    if (exception.response.status === 422) {
      _.each(exception.response.data, (message, key) => {
        if (
          Vue.config.localization.ru.hasOwnProperty(validationKey) &&
          Vue.config.localization.ru[validationKey].hasOwnProperty(key)
        ) {
          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'error',
            text: Vue.config.localization.ru[validationKey][key],
          })
        } else {
          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'error',
            text: message,
          })
        }
      })
    }
  },
}
